import React from "react";
import { styled } from "@mui/material/styles";

import { StepIconProps } from "@mui/material/StepIcon";
import {
  CheckCircleOutline,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";

const IconWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const CustomStepIcon = (props: StepIconProps) => {
  const { active, completed } = props;

  return (
    <IconWrapper>
      {completed ? (
        <CheckCircleOutline sx={{ color: "#4caf50" }} />
      ) : (
        <RadioButtonUncheckedOutlined
          sx={{ color: active ? "#1976d2" : "#1976d2" }}
        />
      )}
    </IconWrapper>
  );
};

export default CustomStepIcon;
